// src/api/index.ts
import { createApiClient } from './client';
import useAuthStore from '../stores/authStore';

// Create a TokenManager that uses the auth store
const tokenManager = {
  getAccessToken: () => useAuthStore.getState().accessToken,
  getRefreshToken: () => useAuthStore.getState().refreshToken,
  setTokens: (accessToken: string, refreshToken: string) => 
    useAuthStore.getState().setTokens(accessToken, refreshToken),
  clearTokens: () => useAuthStore.getState().logout(),
  onTokenRefreshFailed: () => {
    // Handle refresh failure, e.g., redirect to login
    console.log('Token refresh failed');
    //window.location.href = '/login';
  }
};

// Create the API instance with the token manager
export const api = createApiClient(tokenManager);

// Export individual API services
export * from './auth';
// Add more service exports as needed